import type { ModalProps } from '~/util';
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetTitle,
} from '~/primitives/sheet';
import { useAppForm } from '~/util/hooks/useAppForm';
import { formOptions } from '@tanstack/react-form';
import { useApiMutation } from '~/util/hooks/useApiMutation';

import { getRouteApi } from '@tanstack/react-router';
import {
    addClanMemberFormInput,
    addClanMemberFormSchema,
} from '~/util/forms/clan';
import { addClanMemberStaffMutation } from '~/util/mutations/staff/clans';

const Route = getRouteApi('/profile/clan/$clanid');

export const AddClanMemberSheet = (modalProps: ModalProps) => {
    const { clanid } = Route.useParams();
    const mutation = useApiMutation(addClanMemberStaffMutation());

    const addClanMemberForm = useAppForm(
        formOptions({
            formId: 'add-clan-member-staff',
            defaultValues: {
                member: null,
            } as addClanMemberFormInput,
            validators: {
                onChangeAsyncDebounceMs: 500,
                onChange: addClanMemberFormSchema,
            },
            onSubmit: async ({ value }) => {
                mutation.mutate({
                    clanid,
                    memberid: addClanMemberFormSchema.parse(value).member!.id,
                });
            },
        }),
    );

    return (
        <>
            <Sheet {...modalProps}>
                <SheetContent className="w-full sm:w-auto sm:min-w-150 sm:max-w-150 overflow-y-scroll">
                    <SheetHeader>
                        <SheetTitle>Add Clan Member</SheetTitle>
                        <SheetDescription>
                            Add a new member to this clan.
                        </SheetDescription>
                    </SheetHeader>

                    <form
                        id="add-clan-member-staff"
                        onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            addClanMemberForm.handleSubmit();
                        }}
                    >
                        <div className="flex flex-col justify-start items-start gap-x-6 gap-y-3 p-6 pt-6">
                            <addClanMemberForm.AppField name="member">
                                {(field) => (
                                    <field.UserField
                                        label="Member"
                                        required
                                        placeholder="Select a user to add"
                                        tagOptions={{ showFullName: true }}
                                    />
                                )}
                            </addClanMemberForm.AppField>
                        </div>

                        <SheetFooter className="sm:justify-center">
                            <addClanMemberForm.AppForm>
                                <addClanMemberForm.SubscribeButton
                                    label="Add member"
                                    classname="w-2/3"
                                />
                            </addClanMemberForm.AppForm>
                        </SheetFooter>
                    </form>
                </SheetContent>
            </Sheet>
        </>
    );
};
